import { main } from '@/main';
import { Entry } from '@/types/Entry';

main(Entry.Wizard);
